import React from 'react';
import { Link } from 'react-router-dom';
import { canonicalFor, usePageMeta } from '../hooks/usePageMeta';
import { PageHeader } from '../components/page/PageHeader';
import { ContentSection } from '../components/page/ContentSection';
import { CONTACT, techPrepList } from '../data/navigation';
const bigLink = 'inline-flex min-h-[48px] items-center font-mono text-[clamp(1.4rem,2.6vw,1.85rem)] text-navy underline decoration-copper decoration-2 underline-offset-[6px] transition-colors duration-150 ease-precise hover:text-copper';
export function Contact() {
  usePageMeta({
    title: 'Contact Robertson Precision: Sales & Technical Assistance',
    description: 'Sales: 800-397-7745 or sales@sheargeometry.com for pricing, availability and ordering. Shear Geometry technical assistance: 650-224-7511.',
    canonical: canonicalFor('/contact/')
  });
  return <>
      <PageHeader eyebrow="Company" title="Contact Robertson Precision" lead="Call or email for product pricing, availability, ordering and application help. There is no online purchasing." crumbs={[{
      label: 'Home',
      href: '/'
    }, {
      label: 'Contact'
    }]} data-id="element-742" data-mp="ab4odmgwgp2f" />

      <ContentSection id="lines" data-id="element-743" data-mp="1e7qshcy3nmjz">
        <div className="grid gap-px border border-rule bg-rule lg:grid-cols-2" data-id="element-744" data-mp="1e7h41tspdnge">
          <section aria-labelledby="sales-line" className="flex flex-col bg-white p-6 sm:p-8 lg:p-10" data-id="element-745" data-mp="1j7d5pmdxh2ss">
            <p className="font-mono text-[10px] tracking-label text-copper" data-id="element-746" data-mp="mh2qxzsikf5s">SALES</p>
            <h2 id="sales-line" className="mt-3 font-display text-[22px] font-medium text-navy" data-id="element-747" data-mp="qhwgexllu20s">
              Pricing, availability and ordering
            </h2>
            <dl className="mt-6 space-y-5" data-id="element-748" data-mp="vfy09kquu5db">
              <div data-id="element-749" data-mp="10gvgvsw7urcp">
                <dt className="font-mono text-[9.5px] tracking-label text-graphite/70" data-id="element-750" data-mp="10hdjr8ddw3tl">PHONE</dt>
                <dd className="mt-1" data-id="element-751" data-mp="26vcw2l7bur6u">
                  <a href={CONTACT.phoneHref} data-analytics="phone-click" data-analytics-line="sales" data-analytics-location="contact" className={bigLink} data-id="element-752" data-mp="26yily2ns5x3m">
                    {CONTACT.phoneLabel}
                  </a>
                </dd>
              </div>
              <div data-id="element-753" data-mp="1w518e9bu2x0p">
                <dt className="font-mono text-[9.5px] tracking-label text-graphite/70" data-id="element-754" data-mp="1w3gnlbfbmsg1">EMAIL</dt>
                <dd className="mt-1" data-id="element-755" data-mp="1r4dhrorioi70">
                  <a href={CONTACT.emailHref} data-analytics="email-click" data-analytics-location="contact" className="inline-flex min-h-[44px] items-center text-[17px] text-navy underline decoration-copper underline-offset-4 hover:text-copper" data-id="element-756" data-mp="13gceovd3xtyz">
                    {CONTACT.email}
                  </a>
                </dd>
              </div>
            </dl>
            <p className="mt-6 text-[14.5px] leading-relaxed text-graphite/80" data-id="element-757" data-mp="ko9vbc92zzl1">
              Prefer to write it out? The{' '}
              <Link to="/#product-guidance" data-analytics="product-guidance-cta" data-analytics-location="contact" className="text-navy underline decoration-copper underline-offset-4 hover:text-copper" data-id="element-758" data-mp="2rewpfsqfmdz8">
                application request form
              </Link>{' '}
              opens your own email app with the details filled in — nothing is
              sent from this website.
            </p>
          </section>

          <section aria-labelledby="tech-line" className="flex flex-col bg-white p-6 sm:p-8 lg:p-10" data-id="element-759" data-mp="3f3z36phy3mog">
            <p className="font-mono text-[10px] tracking-label text-copper" data-id="element-760" data-mp="314pxwkva2cz9">
              TECHNICAL ASSISTANCE
            </p>
            <h2 id="tech-line" className="mt-3 font-display text-[22px] font-medium text-navy" data-id="element-761" data-mp="35507s8m6xnje">
              {CONTACT.techAssistSentence}
            </h2>
            <div className="mt-6" data-id="element-762" data-mp="1tqwez5rca5fx">
              <a href={CONTACT.techPhoneHref} data-analytics="phone-click" data-analytics-line="technical" data-analytics-location="contact" className={bigLink} data-id="element-763" data-mp="1trxov6wmclw2">
                {CONTACT.techPhoneLabel}
              </a>
              <p className="mt-2 text-[14.5px] text-graphite/80" data-id="element-764" data-mp="208ze2asdom92">
                End users are welcome to call.
              </p>
            </div>
            <h3 className="mt-8 font-mono text-[10px] tracking-label text-graphite/70" data-id="element-765" data-mp="2swv8f8uh622o">
              HAVE THIS READY
            </h3>
            <ul className="mt-3 divide-y divide-rule border-y border-rule" data-id="element-766" data-mp="2nytsgwsciivf">
              {techPrepList.map(item => <li key={item} className="flex gap-3 py-2.5 text-[14.5px] text-graphite" data-id="element-767" data-mp="2ix4fvcph5x58">
                  <span aria-hidden="true" className="mt-2.5 h-px w-3 shrink-0 bg-copper" data-id="element-768" data-mp="2ewc86nw940b2" />
                  {item}
                </li>)}
            </ul>
          </section>
        </div>

        <div className="mt-8 border-l-2 border-copper bg-warm px-5 py-4" data-id="element-769" data-mp="13gdrbxuu09za">
          <p className="font-mono text-[10px] tracking-label text-copper" data-id="element-770" data-mp="3f63j3dpu1sbf">MAILING ADDRESS</p>
          <address className="mt-2 text-[15px] not-italic text-graphite" data-id="element-771" data-mp="3j646hnuwtdum">
            {CONTACT.mailingAddress}
          </address>
          <p className="mt-1.5 text-[13.5px] text-graphite/75" data-id="element-772" data-mp="3o4fh40t13sdw">
            Mailing address only — not a shop, showroom or pickup location.
          </p>
        </div>
      </ContentSection>
    </>;
}